/**
 * File: PageLoading.tsx
 * Path: apps/admin/src/modules/layout/components/PageLoading.tsx
 * Description: What the canvas shows for the moment a page's code is still
 * downloading (pages load on demand, see AppRouter.tsx). One quiet line, styled
 * like the other "Loading…" states, so a fast connection barely sees it.
 */

import React from "react";

export const PageLoading: React.FC = () => (
  <p role="status" className="py-stack-md text-sm text-muted-foreground">
    Loading…
  </p>
);
